// FundSubscriptionController
app.controller('FundSubscriptionController', ['$scope', '$timeout', '$routeParams',
    'WdHttpService', 'config', 'analyticsService', '$sce', 'sessionService',
    function ($scope, $timeout, $routeParams, WdHttpService, config,
        analyticsService, $sce, sessionService) {

        $scope.init = function () {
            $scope.form = {};
            $scope.fee_key = "";
        }

        $scope.$on('PrepareSubscribeForm', async function (evt, data) {
            // console.log('PrepareSubscribeForm EVENT Catched');
            $scope.showPageLoader();
            await $scope.initializeInvestModalData(data);
            $scope.hidePageLoader();
        });

        $scope.$on('OpenSubscriptionUserFlow', async function (e) {
            // console.log('OpenSubscriptionUserFlow EVENT Catched');
            $scope.showPageLoader();
            await $scope.resetAndOpenInvestModal();
            $scope.hidePageLoader();
        });

        $scope.$on('PrepareAndOpenSubscriptionUserFlow', async function (evt, data) {
            console.log('PrepareAndOpenSubscriptionUserFlow EVENT Catched');
            $scope.showPageLoader();
            console.log('modal initialization started');
            await $scope.initializeInvestModalData(data);
            console.log('modal initialization completed');
            $scope.showPageLoader();

            console.log('modal reset & open procedure started');
            await $scope.resetAndOpenInvestModal();
            console.log('modal reset & open procedure completed');
            $scope.hidePageLoader();
        });

        $scope.initializeInvestModalData = async function (data) {
            if (data.fund_details) {
                $scope.fund_details = data.fund_details;
                $scope.setMinimumSipAmount($scope.fund_details);
            } else if (data.fundName) {
                await $scope.getFundDetails(fundName);
            } else if (!$scope.fund_details) {
                $scope.showErrorPopup('Wealth basket details are not fetch, cannot proceed.');
                throw 'Wealth basket details are not fetch, cannot proceed.';
            }

            if (data.isAdviserResearchAnalyst) {
                $scope.isAdviserResearchAnalyst = data.isAdviserResearchAnalyst;
            } else if (data.fund_details) {
                $scope.isAdviserResearchAnalyst = data.fund_details.wealthBasketType == 'RA' ? true : false;
            }

            if (data.userRiskValue) {
                $scope.userRiskValue = data.userRiskValue;
            } else if (sessionService.isLoggedIn()) {
                $scope.userRiskValue = await WdHttpService._get_user_risk_profile(true);
                $scope.userRiskValue = ['LOW', 'MEDIUM', 'HIGH'].includes($scope.userRiskValue) ? $scope.userRiskValue : undefined;
            }

            if (data.paymentData) { //optional params
                $scope.existingPaymentOrderId = data.paymentData.orderId;
                $scope.investingMode = data.paymentData.investingMode;
                $scope.investmentType = data.paymentData.investmentType ? data.paymentData.investmentType.toUpperCase() : undefined;
                $scope.allowedInvestmentType = data.paymentData.investmentType ? data.paymentData.investmentType.toUpperCase() : undefined;
                $scope.purpose = data.paymentData.investmentPurpose
            } else {
                $scope.existingPaymentOrderId = undefined;
            }

            if (data.disallowInvestmentUserChanges) {
                $scope.disallowInvestmentUserChanges = true;
            }

            if (data.advisoryFeeStatus && data.minAmnt) {
                $scope.advisoryFeeStatus = data.advisoryFeeStatus;
                $scope.minAmnt = data.minAmnt;
                $scope.investmentAmt = parseInt(data.minAmnt);
                $scope.investmentAmtOriginally = parseInt(data.minAmnt);
            } else if (sessionService.isLoggedIn()) {
                var request_data = {
                    fund: $scope.fund_details.fundName,
                    adviser: $scope.fund_details.adviserUsername
                };
                await WdHttpService._user_composition(request_data)
                    .then(async function (response) {
                        if (response.status == 200) {
                            if (response.data.isFeePaid) {
                                $scope.advisoryFeeStatus = 'PAID';
                            } else {
                                $scope.advisoryFeeStatus = 'NA';
                            }
                            $scope.minAmnt = response.data.minLumpSumAmount;
                            $scope.investmentAmt = parseInt(response.data.minLumpSumAmount);
                            $scope.investmentAmtOriginally = parseInt(response.data.minLumpSumAmount);
                        }
                    });
            }

            if (sessionService.isLoggedIn()) {
                await $scope.decideFieldsToShow();
            }
        }

        $scope.setMinimumSipAmount = function (fund_details) {
            if (fund_details.childFund != undefined) {
                if (fund_details.childFund.length > 0) {
                    $scope.investmentSipAmt = parseInt(fund_details.childFund[0].minAmount);
                    $scope.investmentSipAmtOriginally = parseInt(fund_details.childFund[0].minAmount);
                    for (var i = 0; i < fund_details.childFund.length; i++) {
                        if (fund_details.childFund[i].minAmount < $scope.investmentSipAmt) {
                            $scope.investmentSipAmt = parseInt(fund_details.childFund[i].minAmount);
                            $scope.investmentSipAmtOriginally = parseInt(fund_details.childFund[i].minAmount);
                        }
                    }
                }
            }
        }

        $scope.resetAndOpenInvestModal = async function () {
            await $('#byFundModal').modal('show');
            await $scope.prepareModal($scope.fund_details);
            $scope.resetInvestModal();
            $scope.openInvestModal();
        }

        $scope.setForm = function (form) {
            $scope.form.riaKyc = form;
        }

        $scope.getFundDetails = async function (fundname) {
            var data = { q: "fundName:" + fundname }
            $scope.showPageLoader();
            await WdHttpService._get_funds(data)
                .then(async function (response) {
                    if (response.status == 200) {
                        var fund_details;
                        // This if condition is coded due to a server side bug to be fixed yet.
                        if (response.data.Items.length > 1) {
                            response.data.Items.forEach(fund => {
                                if (fund.fundName == fundname)
                                    fund_details = fund;
                            });
                        } else
                            fund_details = response.data.Items[0];

                        $scope.fund_details = fund_details;
                        $scope.setMinimumSipAmount($scope.fund_details);
                    }
                });
        }

        $scope.datePicker = function (element) {
            $scope.sipDay = element;
            for (var i = 1; i < 29; i++) {
                var id = "object-".concat(i.toString());
                var sipDatePick = document.getElementById(id);
                sipDatePick.style.backgroundColor = "#80cbc4";
            }
            var id = "object-".concat(element.toString());
            var sipDatePick = document.getElementById(id);
            sipDatePick.style.backgroundColor = "#fff";
        }

        $scope.datePickerPopup = {
            opened: false
        };

        $scope.dateOptions = {
            formatYear: 'yyyy',
            maxDate: setMaxDate(),
            initDate: setMaxDate()
        };

        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.altInputFormats = ['M!/d!/yyyy'];

        $scope.prepareModal = async function (fund_details) {
            // $scope.isAdviserResearchAnalyst = fund_details.wealthBasketType == 'RA' ? true : false;
            $scope.fundName = fund_details.fundName;
            $scope.adviserUsername = fund_details.adviserUsername;
            let distributorName = $scope.isDistributor ? sessionService.get("distributorName") : $scope.adviserUsername;
            // set radio button active
            $scope.radio_investment_type = "LUMPSUM";
            if (sessionService.isLoggedIn()) {
                if (!$scope.isAdviserResearchAnalyst) {
                    $scope.agreementButtonText = 'I Agree to End User Agreement Terms <br/> using OTP based authentication';
                    if ($scope.userRiskValue && config.IS_RIA_FLOW_ENABLED) {
                        await WdHttpService._get_user_adviser_agreement(fund_details.fundName, fund_details.adviserUsername, $scope.isAdviserResearchAnalyst), distributorName
                            .then(response => {
                                $scope.agreementText = response.agreementCopy;
                                $scope.$evalAsync();
                            }).catch(error => {
                                console.log(error);
                                $scope.showErrorPopup("Fetching agreement failed, please reach out to us at support@wealthdesk.in or +91 8588 00 8835. Without Agreement signing you cannot proceed.", () => window.location.href = '/contact-us');
                            });
                    }
                } else {
                    $scope.agreementButtonText = 'I Agree to End User Terms And Conditions & Proceed';
                    $scope.analystAgreementStatus = await WdHttpService._get_user_adviser_analyst_agreement_status(fund_details.adviserUsername);
                    if ($scope.analystAgreementStatus != "SIGNED") {
                        let distributorName = $scope.isDistributor ? sessionService.get("distributorName") : $scope.adviserUsername;
                        await WdHttpService._get_user_adviser_agreement(fund_details.fundName, fund_details.adviserUsername, $scope.isAdviserResearchAnalyst, distributorName)
                            .then(response => {
                                $scope.agreementText = response.agreementCopy;
                                $scope.$evalAsync();
                            }).catch(error => {
                                console.log(error);
                                $scope.showErrorPopup("Fetching agreement failed, please reach out to us at support@wealthdesk.in or +91 8588 00 8835. Without Agreement signing you cannot proceed.", () => window.location.href = '/contact-us');
                            });
                    }
                }
            }


        }

        $scope.showErrorMessageInSubscribeForm = function (message) {
            $scope.subStatus = true;
            $scope.subcritionErrorMsg = message;
            $timeout(function () {
                $scope.subStatus = false;
            }, 5000);
        }

        $scope.resetInvestModal = function () {
            $scope.buyFundAgreement = false;
            if (config.IS_RIA_FLOW_ENABLED && !$scope.isAdviserResearchAnalyst) {
                $scope.buyFundKyc = true;
                $scope.buyMoreFund = false;
                if ($scope.form) {
                    if ($scope.form.riaKyc.$valid) {
                        $scope.buyFundKyc = false;
                        $scope.buyFundAgreement = true;
                    }
                }
            } else if (config.IS_RIA_FLOW_ENABLED && $scope.isAdviserResearchAnalyst) {
                $scope.buyFundKyc = false;
                if ($scope.isAdviserResearchAnalyst && $scope.analystAgreementStatus != "SIGNED") {
                    $scope.buyFundAgreement = true;
                    $scope.buyMoreFund = false;
                } else {
                    $scope.buyMoreFund = true;
                }
            } else {
                $scope.buyFundKyc = false;
                $scope.buyMoreFund = true;
            }

            $scope.showOTPInput = false;

            $scope.$evalAsync();
        }

        $scope.openInvestModal = async function () {
            if ($scope.investmentAmtOriginally) {
                // $scope.showPageLoader();

                await analyticsService._push_custom_event_data_to_datalayer('invest-modal-opened-for-subscription-' + $scope.investmentPurpose.toLowerCase(), {});

                if (config.IS_RIA_FLOW_ENABLED)
                    $scope.isRiskHigher = $scope.isAdviserResearchAnalyst ? false : isFundRiskHigher($scope.fund_details.risk, $scope.userRiskValue);

                // $scope.hidePageLoader();
                // $('#byFundModal').modal('show');
                $('#totalInvAmount').val($scope.minAmnt);
                $('#totalSipInvAmount').val($scope.investmentSipAmtOriginally);
            } else {
                $scope.showProcessingPopup('Kindly be in good network connectivity, as you might expect delays due to low connectivity.');
            }
        }

        $scope.resendAgreementOtp = async function () {
            $scope.showLoading("#otpResendButton");
            await WdHttpService._post_user_adviser_agreement_initiate($scope.fundName, $scope.adviserUsername, $scope.mobile, $scope.isAdviserResearchAnalyst)
                .then(response => {
                    $scope.otpErrorMessage = "OTP has been sent again. Kindly wait for 30 sec before you retry.";
                    $scope.showOtpErrorMessage = true;
                    $scope.disableOtpResend = true;
                    $scope.$evalAsync();
                    $timeout(function () {
                        $scope.otpErrorMessage = undefined;
                        $scope.showOtpErrorMessage = false;
                        $scope.disableOtpResend = false;
                        $scope.$evalAsync();
                    }, 30 * 1000);
                }).catch(error => {
                    console.log(error);
                });
            $scope.stopLoading("#otpResendButton");
        }

        $scope.submitOtpField = async function (mobileNumber) {

            $scope.showLoading('#otpSubmitButton');
            $scope.otpErrorMessage = undefined;
            $scope.showOtpErrorMessage = false;
            await WdHttpService._post_user_adviser_agreement_complete_signing($scope.fundName, $scope.adviserUsername, mobileNumber, $scope.isAdviserResearchAnalyst)
                .then(response => {
                    if (response.status == 'OTP_VERIFIED' || $scope.isAdviserResearchAnalyst) {
                        WdHttpService._post_user_adviser_agreement($scope.fundName, $scope.adviserUsername, mobileNumber, $scope.agreementText, $scope.isAdviserResearchAnalyst)
                            .then(async response => {

                                if ($scope.isRiskHigher && $scope.isAdviserResearchAnalyst == false) {
                                    WdHttpService._put_risk_profile($scope.fund_details.risk, $scope.fundName, $scope.adviserUsername, $scope.userRiskValue);
                                }

                                $scope.buyFundAgreement = false;
                                if ($scope.disallowInvestmentUserChanges) {
                                    $scope.showPageLoader();
                                    $scope.validateSubscribeFormSubmission($scope.investmentType == 'LUMPSUM' ? 'totalInvAmount' : 'totalSipInvAmount', -1);
                                    $scope.buyMoreFund = false;
                                } else {
                                    $scope.buyMoreFund = true;
                                }
                                $scope.stopLoading("#agreementSubmitButton");
                                $scope.stopLoading('#otpSubmitButton');
                                $scope.showOTPInput = false;
                                $scope.$evalAsync();
                            })
                            .catch(error => {
                                console.log(error);
                                $scope.showErrorPopup(error);
                                $('#byFundModal').modal('hide');
                                $scope.stopLoading('#otpSubmitButton');
                                $scope.stopLoading('#agreementSubmitButton');
                            });
                    } else {
                        if ($scope.isAdviserResearchAnalyst == false)
                            $scope.otpErrorMessage = "The OTP you entered is incorrect. Please enter the correct OTP.";
                        else
                            $scope.otpErrorMessage = "Something went wrong. Please try again";
                        $scope.showOtpErrorMessage = true;
                        $scope.stopLoading('#otpSubmitButton');
                        $scope.stopLoading('#agreementSubmitButton');
                        $scope.$evalAsync();
                    }
                }).catch(error => {
                    $('#otpModal').modal('hide');
                    console.log(error);
                    $scope.showErrorPopup(error);
                    $scope.stopLoading('#otpSubmitButton');
                });
        }

        $scope.sendAgreementOtp = async function () {
            $scope.showLoading("#agreementSubmitButton");
            var profileData = await WdHttpService._get_dynamodb_user_profile(false);
            $scope.mobile = profileData.phoneNumber ? profileData.phoneNumber.replace('+91', '') : undefined;
            await WdHttpService._post_user_adviser_agreement_initiate($scope.fundName, $scope.adviserUsername, $scope.mobile, $scope.isAdviserResearchAnalyst)
                .catch(error => {
                    console.log(error);
                    $scope.showErrorPopup(error);
                });
            if ($scope.isAdviserResearchAnalyst) {
                $scope.submitOtpField('111111');
            } else {
                $scope.showOTPInput = true;
                $scope.stopLoading("#agreementSubmitButton");
                $scope.$evalAsync();
            }
        }

        $scope.validateSubscribeFormSubmission = function (elementId, minAmount) {
            $scope.submitted = true;
            if (minAmount == -1 && $scope.disallowInvestmentUserChanges) // The User is not required to change the investment amount and investment type
                $scope.userInvestingAmount = -1;
            else
                $scope.userInvestingAmount = $("#" + elementId).val().replace(/,/g, ''); //totalSipInvAmount

            if (elementId == 'totalSipInvAmount') {
                if ($scope.sipDay == undefined) {
                    $scope.showErrorMessageInSubscribeForm('Please select a SIP Date');
                }
            }

            if (parseFloat($scope.userInvestingAmount) < minAmount) { //$scope.investmentSipAmt
                $scope.showErrorMessageInSubscribeForm('Amount must be more than Minimum Investment Amount shown above');
            } else if ($scope.userInvestingAmount == 'NaN') {
                $scope.showErrorMessageInSubscribeForm('Amount must be a number.');
            } else if ($scope.userInvestingAmount == 0) {
                $scope.showErrorMessageInSubscribeForm('Amount must be a number.');
            } else {
                $scope.submitInvestingAmount($scope.userInvestingAmount, elementId == 'totalSipInvAmount' ? 'SIP' : 'LUMPSUM');
            }
            return;
        };

        $scope.trustAction = function () {
            return $sce.trustAsResourceUrl(config.PAYTM_URL);
        };

        $scope.submitInvestingAmount = async function (amount, investmentType) {
            investmentType == "SIP" ? $scope.showLoading('#sipInvestButton') : $scope.showLoading('#lumpsumInvestButton');
            $scope.investmentPurpose = $scope.existingPaymentOrderId != undefined ? $scope.purpose : 'EQUITYSUBSCRIPTION'; //EQUITYSUBSCRIPTION, ADDITIONALSUBSCRIPTION, RENEWAL
            $scope.investmentType = investmentType;
            $scope.radio_investType = $scope.investmentType;
            if ($scope.investmentType == 'SIP') {
                $scope.minimumAmountForAdvisoryPayment = parseInt($scope.investmentSipAmtOriginally);
            } else {
                $scope.minimumAmountForAdvisoryPayment = parseInt($scope.fund_details.minAmount);
            }

            var validateMoreThanMinLumpsum = amount >= $scope.minimumAmountForAdvisoryPayment;
            if ($scope.disallowInvestmentUserChanges)
                validateMoreThanMinLumpsum = true;
            if ($scope.fund_details && validateMoreThanMinLumpsum) {
                $scope.investmentAmount = amount;
                await WdHttpService._get_user_advisory_fee_amount(
                    $scope.fundName,
                    $scope.fund_details.adviserUsername,
                    $scope.investmentAmount,
                    $scope.investmentPurpose,
                    $scope.investingMode,
                    $scope.investmentType
                ).then(async response => {
                    if (!response.data) {
                        $scope.hidePageLoader();
                        $scope.showErrorPopup('Could not fetch your Fee Amount, Please try again later or connect with our team to resolve the issue.');
                        return;
                    }
                    $scope.fee_key = response.data.key;
                    if (response.data.feeAmount == 0) {
                        var data = {
                            purpose: $scope.investmentPurpose,
                            investingMode: $scope.investingMode,
                            investmentAmount: $scope.investmentAmount,
                            investmentType: $scope.investmentType,
                            fundName: $scope.fundName,
                            adviserUsername: $scope.fund_details.adviserUsername,
                            sipDay: $scope.sipDay ? $scope.sipDay : 0
                        }
                        await WdHttpService._is_fee_paid(data)
                            .then(async response => {
                                var eventData = {
                                    'fundName': $scope.fundName.toLowerCase()
                                };
                                await analyticsService._push_custom_event_data_to_datalayer('fee-zero-' + $scope.investmentPurpose.toLowerCase() + "-" + $scope.investmentType.toLowerCase(), eventData);

                                window.location.href = "/order-placement?orderId=" + response.data.orderId + "&action=order-placement&path=http://" + window.location.hostname + ':' + window.location.port;
                            }).catch(error => {
                                $scope.showErrorPopup(error);
                            });
                    } else {
                        await $scope.createPaytmOrder(response.data.feeAmount, $scope.investmentType); //feeToAdviser
                    }
                }).catch(error => {
                    console.log(error);
                    $scope.showErrorMessageInSubscribeForm(error);
                })
            } else if (!validateMoreThanMinLumpsum) {
                $scope.showErrorMessageInSubscribeForm("Sorry, you have entered an amount less than the minimum required amount to invest, i.e. " + $scope.minimumAmountForAdvisoryPayment);
            }
            investmentType == "SIP" ? $scope.stopLoading('#sipInvestButton') : $scope.stopLoading('#lumpsumInvestButton');
        }

        $scope.fetchKraKycDetails = async function (kraKycForm) {

            if (kraKycForm.$invalid) {
                return;
            }

            $scope.showLoading("#fetchKraSubmit");
            await WdHttpService._fetch_kra_data($scope.adviserUsername, kraKycForm.panCard.$modelValue, kraKycForm.birthdate.$modelValue)
                .then(response => {
                    $scope.firstName = response.firstName;
                    $scope.lastName = response.lastName;
                    $scope.email = response.email;
                    $scope.mobile = response.phoneNumber.substr(response.phoneNumber.length - 10);
                    $scope.address = response.address.add1 + ' ' + response.address.add2 + ' ' + response.address.add3;
                    $scope.city = response.address.city;
                    $scope.stateField = $scope.stateList.includes(response.address.state.toUpperCase()) ? response.address.state.toUpperCase() : 'OTHERS';
                    $scope.pincode = parseInt(response.address.pincode);

                    setTimeout(() => {
                        if ($scope.form.riaKyc.$invalid)
                            $scope.kraDataFetched = false;
                        else
                            $scope.kraDataFetched = true;
                        $scope.$evalAsync();
                    }, 1000);
                    $scope.showKraForm = false;
                }).catch(error => {
                    console.log(error);
                    $scope.kraDataFetched = false;
                    $scope.showKraForm = false;
                })
            $scope.stopLoading("#fetchKraSubmit");
            $scope.$evalAsync();
        }

        $scope.createPaytmOrder = async function (feeAmount, type) {
            if (type == undefined) {
                $scope.showErrorPopup('Type is undefined');
                return;
            }
            $scope.formSubmittedOnce = true;
            $scope.amt = feeAmount;
            $scope.gstAmt = ($scope.amt * .18).toFixed(2);
            $scope.payment_charges = 0;
            $scope.totalAmt = parseFloat($scope.amt) + parseFloat($scope.gstAmt) + parseFloat($scope.payment_charges);
            $scope.totalAmt = $scope.totalAmt.toFixed(2);

            $scope.paytm_data_request = {
                TXN_AMOUNT: $scope.totalAmt,
                FEE_AMOUNT: $scope.amt,
                GST_AMOUNT: $scope.gstAmt,
                PAYMENT_CHARGES: $scope.payment_charges,
                CALLBACK_URL: config.API_ROOT_URL + config.CALLBACK_URL,
                CALLER_DOMAIN: location.host,
                CHANNEL_ID: config.CHANNEL_ID,
                INDUSTRY_TYPE_ID: config.INDUSTRY_TYPE_ID,
                WEBSITE: config.WEBSITE,
                FUND_NAME: $scope.fundName,
                ADVISER_USERNAME: $scope.fund_details.adviserUsername,
                "investment_amount": $scope.investmentAmount,
                "purpose": $scope.investmentPurpose,
                "investment_type": type,
                "sipDay": $scope.sipDay ? $scope.sipDay : 0,
                "key": $scope.fee_key
            };

            await WdHttpService._create_order_checksum($scope.paytm_data_request)
                .then(response => {
                    $scope.paytm_data = response.data;
                    $scope.buyMoreFund = false;
                    $scope.paymentDetailModal = true;
                    $scope.hidePageLoader();
                    $scope.$evalAsync();
                }).catch(error => {
                    $scope.showErrorMessageInSubscribeForm(error);
                });
        }

        $scope.stateList = ["Punjab", "Himachal Pradesh", "Jammu and Kashmir", "Chandigarh",
            "Uttarakhand", "Haryana", "Delhi", "Rajasthan", "Uttar Pradesh", "Bihar", "Sikkim",
            "Arunachal Pradesh", "Assam", "Manipur", "Mizoram", "Tripura",
            "Meghalaya", "Nagaland", "West Bengal", "Jharkhand",
            "Odisha", "Chhattisgarh", "Madhya Pradesh", "Gujarat",
            "Daman and Diu", "Dadra and Nagar Haveli", "Maharashtra",
            "Andhra Pradesh", "Karnataka", "Goa", "Lakshadweep",
            "Kerala", "Tamil Nadu", "Puducherry", "Andaman and Nicobar Islands", "Others", "Telangana"
        ].map(state => state.toUpperCase());

        $scope.countryList = ["Albania", "Aland Islands", "Afghanistan", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua And Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium",
            "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia And Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic",
            "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, The Democratic Republic Of The", "Cook Islands", "Costa Rica", "Cote D'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador",
            "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland",
            "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island And Mcdonald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran, Islamic Republic Of", "Iraq", "Ireland", "Isle Of Man", "Israel",
            "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People's Republic Of", "Korea, Republic Of", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg",
            "Macao", "Macedonia, The Former Yugoslav Republic Of", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States Of", "Moldova, Republic Of", "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique",
            "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestinian Territory, Occupied", "Panama", "Papua New Guinea", "Paraguay", "Peru",
            "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Helena", "Saint Kitts And Nevis", "Saint Lucia", "Saint Pierre And Miquelon", "Saint Vincent And The Grenadines", "Samoa", "San Marino", "Sao Tome And Principe", "Saudi Arabia", "Senegal",
            "Serbia And Montenegro", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia And The South Sandwich Islands", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard And Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan, Province Of China",
            "Tajikistan", "Tanzania, United Republic Of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad And Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks And Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan",
            "Vanuatu", "Venezuela", "Viet Nam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wallis And Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe", "Côte D'ivoire", "Korea,Democratic People'sRepublicOf", "Lao People's Democratic Republic"
        ].map(state => state.toUpperCase());

        $scope.decideFieldsToShow = async function () {
            await WdHttpService._get_dynamodb_user_profile(false)
                .then(profileData => {
                    var investorName = profileData.name.split(' ');
                    $scope.firstName = investorName[0] ? investorName[0] : undefined;
                    $scope.lastName = investorName[1] ? investorName[1] : undefined;
                    $scope.email = profileData.email;
                    $scope.mobile = profileData.phoneNumber ? profileData.phoneNumber.replace('+91', '') : undefined;
                    $scope.address = profileData.address['address1'];
                    $scope.city = profileData.address['city'];
                    $scope.stateField = profileData.address['state'] ? profileData.address['state'].toUpperCase() : '';
                    $scope.pincode = profileData.address['pincode'];
                    $scope.brokerName = profileData.brokerCompany;
                    $scope.clientCode = profileData.clientCode;
                    $scope.panCard = profileData.panCard;

                    var tempDate;
                    tempDate = profileData.dateOfBirth
                    if (isNaN(tempDate)) {
                        if (tempDate) {
                            var dateArr = tempDate.split('-');
                            tempDate = new Date(dateArr[2] + '-' + dateArr[1] + '-' + dateArr[0] + 'T00:00');
                        }
                    } else if (!isNaN(tempDate)) {
                        tempDate = new Date(tempDate);
                    } else {
                        tempDate = undefined;
                    }

                    $scope.birthdate = tempDate;
                    $scope.isFormSet = true;
                    $scope.$evalAsync();
                });
        }

        function setMaxDate() {
            // Allow only 18 years back date in DOB field
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear() - 18;
            if (dd < 10) {
                dd = '0' + dd
            }
            if (mm < 10) {
                mm = '0' + mm
            }
            today = yyyy + '-' + mm + '-' + dd;
            // return today;
            return new Date(yyyy, mm - 1, dd);
            // document.getElementById("birthdateField").setAttribute("max", today);
        }

        $scope.submitKYCForm = async function (form) {
            $scope.submitted = true;
            var newChanges = {}
            if ((form.$valid && form.$dirty && !form.$pristine) || (form.$valid && $scope.kraDataFetched)) {
                newChanges['firstName'] = form.firstName.$modelValue;
                newChanges['lastName'] = form.lastName.$modelValue;
                newChanges['email'] = form.email.$modelValue;
                newChanges['phoneNumber'] = '+91' + form.mobile.$modelValue;
                var dob = new Date(form.birthdate.$viewValue);
                newChanges['dateOfBirth'] = (dob.getDate() < 10 ? '0' : '') + dob.getDate() + "-" + (dob.getMonth() < 9 ? '0' : '') + (dob.getMonth() + 1) + "-" + dob.getFullYear();
                newChanges['address'] = {};
                newChanges['address']['address1'] = form.address.$modelValue;
                newChanges['address']['state'] = form.state.$modelValue;
                newChanges['address']['city'] = form.city.$modelValue;
                newChanges['address']['pincode'] = form.pincode.$modelValue;
                newChanges['brokerName'] = form.brokerName.$modelValue;
                newChanges['clientCode'] = form.clientCode.$modelValue ? form.clientCode.$modelValue : '';
                newChanges['panCard'] = form.panCard.$modelValue;
                $scope.update_user_kyc_data(newChanges);
            } else if (form.$invalid) {
                $scope.showErrorPopup('Seems like you have missed some fields.');
            } else {
                $scope.buyFundKyc = false;
                $scope.buyFundAgreement = true;
                $scope.$evalAsync();
            }
        }

        $scope.update_user_kyc_data = async function (data) {
            $scope.showLoading("#kycSubmitButton");
            await WdHttpService._post_user_kyc_profile(data)
                .then(async response => {
                    $scope.buyFundKyc = false;
                    $scope.buyFundAgreement = true;
                    $scope.$evalAsync();
                }).catch(error => {
                    console.log(error);
                    $scope.showErrorPopup(error);
                });
            $scope.stopLoading("#kycSubmitButton");
        }
    }
]);